<script>
    import { Bar } from 'vue-chartjs'

    export default {
        extends: Bar,
        props: ['data', 'options'],
        watch: {
            data: function () {
                this.init()
            }
        },
        mounted() {
            this.init()
        },
        methods: {
            init: function () {
                this.renderChart(this.data, this.options)
            }
        }
    }
</script>
